export const ACCEPTED_FILE_EXT = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif'];
